var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-wrapper"},[_c('editor-content',{attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }